export default __webpack_public_path__ + "static/media/interested-in-course-bg1.81d375b3.png";